// BR 巴西逻辑

import vueI18n from '@/i18n/locale'
import caculateWidthBy10FontSize from '../caculateFontSize.js'
import { getMaxValue, getMaxLengthValue, isSmallScreenMobile } from '../utils.js'
import {
  LegendBuilder,
  XAxisBuilder,
  YAxisBuilder,
  WeekendBuilder,
  ToolTipBuilder,
  getEchartHeightAndBottomByLocale,
} from '../builderBR.js'
import { isEmpty } from 'lodash'

const durationCfg = getEchartHeightAndBottomByLocale('serviceDuration')
const serviceDurationBottom = durationCfg.bottom
const serviceDurationBottomHor = durationCfg.bottomHor

const timeoutCfg = getEchartHeightAndBottomByLocale('serviceTimeout')
const serviceTimeoutBottom = timeoutCfg.bottom
const serviceTimeoutBottomHor = timeoutCfg.bottomHor

const cancelCfg = getEchartHeightAndBottomByLocale('serviceCancel')
const serviceCancelBottom = cancelCfg.bottom
const serviceCancelBottomHor = cancelCfg.bottomHor

const questionCfg = getEchartHeightAndBottomByLocale('serviceQuestion')
const serviceQuestionBottom = questionCfg.bottom
const serviceQuestionBottomHor = questionCfg.bottomHor

export default function transformer(
  data = {},
  dateToWeek,
  key = 'service',
  direction,
  isFullIndicator = true, // 是否展示Service(服务版块)全部Tab
) {
  const verticalHeight = isSmallScreenMobile()
    ? 220 // 小屏（竖屏）
    : 220
  const horizontalHeight = isSmallScreenMobile()
    ? 160 // 小屏（横屏）
    : 200
  const chartHeight = direction === 'vertical' ? verticalHeight : horizontalHeight
  const temp = isFullIndicator
    ? [
        parseDurationChartsData(data.chartData, dateToWeek, direction, chartHeight), // 营业时长
        parseTimeoutChartsData(data.chartData, dateToWeek, direction, chartHeight), // 出餐超时
        parseCancelChartsData(data.chartData, dateToWeek, direction, chartHeight), // 取消订单
        parseServiceChartsData(data.chartData, dateToWeek, direction, chartHeight), // 问题订单
      ]
    : [
        parseTimeoutChartsData(data.chartData, dateToWeek, direction, chartHeight), // 出餐超时
        parseCancelChartsData(data.chartData, dateToWeek, direction, chartHeight), // 取消订单
        parseServiceChartsData(data.chartData, dateToWeek, direction, chartHeight), // 问题订单
      ]
  const chartData = temp.filter(chart => {
    return chart.isShow
  })
  return {
    title: vueI18n.t('Gattaran_V1__hUDQ' /** 服务 */),
    ...data,
    chartData,
    chartHeight,
    chartkey: key,
  }
}

// 营业时长
function parseDurationChartsData(chartData = {}, dateToWeek, direction, chartHeight) {
  // console.log('parse: parseDurationChartsData', chartData)
  const {
    onlineDuration = [], // 日均在线时长
    onlineRatio = [], // 在线率
    peakOnlineDuration = [], // 高峰在线时长
    peakOnlineRatio = [], // 高峰在线率
  } = chartData || {}
  console.log(' 营业时长 chartData', chartData)
  const max = getMaxValue({ onlineDuration })
  const maxConnectivity = getMaxLengthValue({ onlineRatio })
  const xAxisData = onlineDuration.map(item => item.date)
  const left = (max ? caculateWidthBy10FontSize(max) + 8 : 16) + 26
  const right =
    (maxConnectivity
      ? caculateWidthBy10FontSize(maxConnectivity + '%')
      : caculateWidthBy10FontSize(0, 5)) + 10

  return {
    isShow: [onlineDuration, onlineRatio, peakOnlineDuration, peakOnlineRatio].some(
      i => !isEmpty(i),
    ),
    grid: {
      top: 26,
      left,
      right,
      bottom: direction === 'vertical' ? serviceDurationBottom : serviceDurationBottomHor,
    },
    tooltip: ToolTipBuilder({
      position: { left: 0, bottom: chartHeight },
    }),
    legend: LegendBuilder([
      vueI18n.t('Gattaran_opt_xawD_vBtI' /** 日均在线时长 */),
      {
        name: vueI18n.t('Gattaran_ES_ZfMz_IKyd' /** 在线率 */),
        icon: 'path://M960 470.857143H64c-5.028571 0-9.142857 4.114286-9.142857 9.142857v64c0 5.028571 4.114286 9.142857 9.142857 9.142857h896c5.028571 0 9.142857-4.114286 9.142857-9.142857v-64c0-5.028571-4.114286-9.142857-9.142857-9.142857z',
      },
      vueI18n.t('FoodB_requirement_aAaC_nmQK' /** 高峰在线时长 */),
      {
        name: vueI18n.t('FoodB_Side_YfKV_vTcN' /** 高峰时段在线率 */),
        icon: 'path://M960 470.857143H64c-5.028571 0-9.142857 4.114286-9.142857 9.142857v64c0 5.028571 4.114286 9.142857 9.142857 9.142857h896c5.028571 0 9.142857-4.114286 9.142857-9.142857v-64c0-5.028571-4.114286-9.142857-9.142857-9.142857z',
      },
    ]),
    xAxis: [
      XAxisBuilder({
        data: xAxisData.map(item => item.substring(5)),
      }),
    ],
    yAxis: [
      YAxisBuilder({
        name: vueI18n.t('Gattaran_opt_JcLo_plhe' /** 在线时长 */),
        nameTextStyle: {
          color: '#8D9099',
          fontSize: 10,
          align: 'left',
          padding: [0, 0, 0, -left + 8],
        },
      }),
      YAxisBuilder({
        name: vueI18n.t('Gattaran_ES_ZfMz_IKyd' /** 在线率 */) + '%',
        nameTextStyle: {
          color: '#8D9099',
          fontSize: 10,
          align: 'right',
          padding: [0, -right + 8, 0, 0],
        },
        axisLabel: {
          formatter: '{value}%',
          fontSize: 10,
          color: '#8D9099',
        },
        splitLine: {
          show: false,
        },
      }),
    ],
    series: [
      {
        name: vueI18n.t('Gattaran_opt_xawD_vBtI' /** 日均在线时长 */),
        type: 'bar',
        barWidth: 4,
        color: '#8D9099',
        stack: 'test',
        data: onlineDuration.map(item => item.value),
        silent: true,
      },
      {
        name: vueI18n.t('Gattaran_ES_ZfMz_IKyd' /** 在线率 */),
        type: 'line',
        showSymbol: false,
        yAxisIndex: 1,
        color: '#FFC9AD',
        lineStyle: {
          width: 1.5,
        },
        data: onlineRatio.map(item => item.value),
      },
      {
        name: vueI18n.t('FoodB_requirement_aAaC_nmQK' /** 高峰在线时长 */),
        type: 'bar',
        barWidth: 4,
        color: '#F8AD21',
        stack: 'test',
        data: peakOnlineDuration.map(item => item.value),
        silent: true,
      },
      {
        name: vueI18n.t('FoodB_Side_YfKV_vTcN' /** 高峰时段在线率 */),
        type: 'line',
        showSymbol: false,
        yAxisIndex: 1,
        color: '#F76A31',
        lineStyle: {
          width: 1.5,
        },
        data: peakOnlineRatio.map(item => item.value),
      },
      WeekendBuilder(xAxisData, dateToWeek),
    ],
  }
}

// 出餐超时
function parseTimeoutChartsData(chartData = {}, dateToWeek, direction, chartHeight) {
  console.log('parse: parseTimeoutChartsData', chartData)
  // 出餐超时订单数、出餐超时率
  const { deliveryOrdersCntRadio = [], deliveryOrdersCntRate = [] } = chartData || {}
  const max = getMaxValue({ deliveryOrdersCntRadio })
  const maxConnectivity = getMaxLengthValue({ deliveryOrdersCntRate })
  const xAxisData = deliveryOrdersCntRadio.map(item => item.date)
  const left = (max ? caculateWidthBy10FontSize(max) + 8 : 16) + 8
  const right =
    (maxConnectivity
      ? caculateWidthBy10FontSize(maxConnectivity + '%')
      : caculateWidthBy10FontSize(0, 5)) + 10

  return {
    isShow: [deliveryOrdersCntRadio, deliveryOrdersCntRate].some(i => !isEmpty(i)),
    grid: {
      top: 26,
      left,
      right,
      bottom: direction === 'vertical' ? serviceTimeoutBottom : serviceTimeoutBottomHor,
    },
    tooltip: ToolTipBuilder({
      position: { left: 0, bottom: chartHeight },
    }),
    legend: LegendBuilder([
      vueI18n.t('FoodB_requirement_puhp_VPIQ' /** 出餐超时订单数 */),
      {
        name: vueI18n.t('FoodB_requirement_uBiP_YocR' /** 出餐超时率 */),
        icon: 'path://M960 470.857143H64c-5.028571 0-9.142857 4.114286-9.142857 9.142857v64c0 5.028571 4.114286 9.142857 9.142857 9.142857h896c5.028571 0 9.142857-4.114286 9.142857-9.142857v-64c0-5.028571-4.114286-9.142857-9.142857-9.142857z',
      },
    ]),
    xAxis: [
      XAxisBuilder({
        data: xAxisData.map(item => item.substring(5)),
      }),
    ],
    yAxis: [
      YAxisBuilder({
        name: vueI18n.t('Gattaran_opt_JcLo_plhe' /** 在线时长 */),
        nameTextStyle: {
          color: '#8D9099',
          fontSize: 10,
          align: 'left',
          padding: [0, 0, 0, -left + 8],
        },
      }),
      YAxisBuilder({
        name: vueI18n.t('Gattaran_ES_ZfMz_IKyd' /** 在线率 */) + '%',
        nameTextStyle: {
          color: '#8D9099',
          fontSize: 10,
          align: 'right',
          padding: [0, -right + 8, 0, 0],
        },
        axisLabel: {
          formatter: '{value}%',
          fontSize: 10,
          color: '#8D9099',
        },
        splitLine: {
          show: false,
        },
      }),
    ],
    series: [
      {
        name: vueI18n.t('FoodB_requirement_puhp_VPIQ' /** 出餐超时订单数 */),
        type: 'bar',
        barWidth: 4,
        color: '#F76A31',
        stack: 'test',
        data: deliveryOrdersCntRadio.map(item => item.value ?? '--'),
        silent: true,
      },
      {
        name: vueI18n.t('FoodB_requirement_uBiP_YocR' /** 出餐超时率 */),
        type: 'line',
        showSymbol: false,
        yAxisIndex: 1,
        color: '#5BD4AB',
        lineStyle: {
          width: 1.5,
        },
        data: deliveryOrdersCntRate.map(item => item.value ?? '--'),
      },
      WeekendBuilder(xAxisData, dateToWeek),
    ],
  }
}

// 已取消的订单
function parseCancelChartsData(chartData = {}, dateToWeek, direction, chartHeight) {
  const {
    timeoutCancelOrdersNum = [],
    soldoutCancelOrdersNum = [],
    otherReasonsCancelOrdersNum = [],
    cancellationRatio = [],
  } = chartData || {}
  const max = getMaxValue({
    timeoutCancelOrdersNum,
    soldoutCancelOrdersNum,
    otherReasonsCancelOrdersNum,
  })
  const maxRadio = getMaxLengthValue({ cancellationRatio })
  const xAxisData = timeoutCancelOrdersNum.map(item => item.date)
  const left = (max ? caculateWidthBy10FontSize(max) + 8 : 16) + 8
  const right =
    (maxRadio ? caculateWidthBy10FontSize(maxRadio + '%') : caculateWidthBy10FontSize(0, 5)) + 10

  return {
    isShow: [
      timeoutCancelOrdersNum,
      soldoutCancelOrdersNum,
      otherReasonsCancelOrdersNum,
      cancellationRatio,
    ].some(i => !isEmpty(i)),
    grid: {
      top: 26,
      left,
      right,
      bottom: direction === 'vertical' ? serviceCancelBottom : serviceCancelBottomHor,
    },
    tooltip: ToolTipBuilder({
      position: { left: 0, bottom: chartHeight },
    }),
    legend: LegendBuilder([
      vueI18n.t('Gattaran_opt_slKF_FRuu' /** 超时未接 */),
      vueI18n.t('Gattaran_opt_SsHX_vUuN' /** 售罄 */),
      vueI18n.t('Gattaran_opt2_UTsL_QVlH' /** 其他 */),
      {
        name: vueI18n.t('Gattaran_V1__xaNO' /** Cancellation Rate */),
        icon: 'path://M960 470.857143H64c-5.028571 0-9.142857 4.114286-9.142857 9.142857v64c0 5.028571 4.114286 9.142857 9.142857 9.142857h896c5.028571 0 9.142857-4.114286 9.142857-9.142857v-64c0-5.028571-4.114286-9.142857-9.142857-9.142857z',
      },
    ]),
    xAxis: XAxisBuilder({ data: xAxisData.map(item => item.substring(5)) }),
    yAxis: [
      YAxisBuilder({
        name: vueI18n.t('FoodOpB_10_Order_volume_WNmq' /** 订单数 */),
        nameTextStyle: {
          color: '#8D9099',
          fontSize: 10,
          align: 'left',
          padding: [0, 0, 0, -left + 8],
        },
      }),
      YAxisBuilder({
        name: vueI18n.t('Gattaran_V1__xaNO' /** B责取消率% */),
        nameTextStyle: {
          color: '#8D9099',
          fontSize: 10,
          align: 'right',
          padding: [0, -right + 8, 0, 0],
        },
        axisLabel: {
          formatter: '{value}%',
          fontSize: 10,
          color: '#8D9099',
        },
        splitLine: {
          show: false,
        },
      }),
    ],
    series: [
      {
        name: vueI18n.t('Gattaran_opt_slKF_FRuu' /** 超时未接 */),
        type: 'bar',
        barWidth: 4,
        color: '#F8AD21',
        stack: 'service',
        data: timeoutCancelOrdersNum.map(item => item.value),
      },
      {
        name: vueI18n.t('Gattaran_opt_SsHX_vUuN' /** 售罄 */),
        type: 'bar',
        barWidth: 4,
        color: '#5BD4AB',
        stack: 'service',
        data: soldoutCancelOrdersNum.map(item => item.value),
      },
      {
        name: vueI18n.t('Gattaran_opt2_UTsL_QVlH' /** 其他 */),
        type: 'bar',
        barWidth: 4,
        color: '#FFC9AD',
        stack: 'service',
        data: otherReasonsCancelOrdersNum.map(item => item.value),
      },
      {
        name: vueI18n.t('Gattaran_V1__xaNO' /** 取消率 */),
        type: 'line',
        yAxisIndex: 1,
        showSymbol: false,
        color: '#4A9DFC',
        data: cancellationRatio.map(item => item.value),
      },
      WeekendBuilder(xAxisData, dateToWeek),
    ],
  }
}

// 问题订单
function parseServiceChartsData(chartData = {}, dateToWeek, direction, chartHeight) {
  const {
    missingItemOrdersNum = [],
    smallPortionsOrdersNum = [],
    differentThanExpectedOrdersNum = [],
    wrongItemOrdersNum = [],
    imperfectOrderRatio = [],
  } = chartData || {}
  const max = getMaxValue({
    missingItemOrdersNum,
    smallPortionsOrdersNum,
    differentThanExpectedOrdersNum,
    wrongItemOrdersNum,
  })
  const maxRadio = getMaxLengthValue({ imperfectOrderRatio })
  const xAxisData = missingItemOrdersNum.map(item => item.date)
  const left = (max ? caculateWidthBy10FontSize(max) + 8 : 16) + 8
  const right =
    (maxRadio ? caculateWidthBy10FontSize(maxRadio + '%') : caculateWidthBy10FontSize(0, 5)) + 10

  return {
    isShow: [
      missingItemOrdersNum,
      smallPortionsOrdersNum,
      differentThanExpectedOrdersNum,
      wrongItemOrdersNum,
      imperfectOrderRatio,
    ].some(i => !isEmpty(i)),
    grid: {
      top: 26,
      left,
      right,
      bottom: direction === 'vertical' ? serviceQuestionBottom : serviceQuestionBottomHor,
    },
    tooltip: ToolTipBuilder({
      position: { left: 0, bottom: chartHeight },
    }),
    legend: LegendBuilder([
      vueI18n.t('FoodC_revision_Less_meal_pHwq' /** 少餐反馈 */),
      vueI18n.t('FoodC_improve__ovBF' /** 份量少 */),
      vueI18n.t('FoodC_improve__ByLg' /** 与预期不符 */),
      vueI18n.t('CS_Aftersale_Wrong_meal_gNCe' /** Completed Orders */),
      {
        name: vueI18n.t('Gattaran_opt2_egxV_xfoW' /** 问题订单率 */),
        icon: 'path://M960 470.857143H64c-5.028571 0-9.142857 4.114286-9.142857 9.142857v64c0 5.028571 4.114286 9.142857 9.142857 9.142857h896c5.028571 0 9.142857-4.114286 9.142857-9.142857v-64c0-5.028571-4.114286-9.142857-9.142857-9.142857z',
      },
    ]),
    xAxis: XAxisBuilder({ data: xAxisData.map(item => item.substring(5)) }),
    yAxis: [
      YAxisBuilder({
        name: vueI18n.t('FoodOpB_10_Order_volume_WNmq' /** 订单数 */),
        nameTextStyle: {
          color: '#8D9099',
          fontSize: 10,
          align: 'left',
          padding: [0, 0, 0, -left + 8],
        },
      }),
      YAxisBuilder({
        name: vueI18n.t('Gattaran_opt2_egxV_xfoW' /** 差评率% */),
        nameTextStyle: {
          color: '#8D9099',
          fontSize: 10,
          align: 'right',
          padding: [0, -right + 8, 0, 0],
        },
        axisLabel: {
          formatter: '{value}%',
          fontSize: 10,
          color: '#8D9099',
        },
        splitLine: {
          show: false,
        },
      }),
    ],
    series: [
      {
        name: vueI18n.t('FoodC_revision_Less_meal_pHwq' /** Negatively Rated Orders */),
        type: 'bar',
        barWidth: 4,
        color: '#FF8D5C',
        stack: 'service',
        data: missingItemOrdersNum.map(item => item.value),
        silent: true,
      },
      {
        name: vueI18n.t('FoodC_improve__ovBF' /** Completed Orders */),
        type: 'bar',
        barWidth: 4,
        color: '#F8AD21',
        stack: 'service',
        data: smallPortionsOrdersNum.map(item => item.value),
        silent: true,
      },
      {
        name: vueI18n.t('FoodC_improve__ByLg' /** Completed Orders */),
        type: 'bar',
        barWidth: 4,
        color: '#FFC9AD',
        stack: 'service',
        data: differentThanExpectedOrdersNum.map(item => item.value),
        silent: true,
      },
      {
        name: vueI18n.t('CS_Aftersale_Wrong_meal_gNCe' /** Completed Orders */),
        type: 'bar',
        barWidth: 4,
        color: '#D14F1F',
        stack: 'service',
        data: wrongItemOrdersNum.map(item => item.value),
        silent: true,
      },
      {
        name: vueI18n.t('Gattaran_opt2_egxV_xfoW' /** 问题订单率 */),
        type: 'line',
        yAxisIndex: 1,
        showSymbol: false,
        color: '#09BA78',
        data: imperfectOrderRatio.map(item => item.value),
        silent: true,
      },
      WeekendBuilder(xAxisData, dateToWeek),
    ],
  }
}
